export default {"src":"/_next/static/media/burst.45095fb9.svg","height":32,"width":32,"blurWidth":0,"blurHeight":0};